import EHerkenningCard from './EHerkenningCard';

export default EHerkenningCard;
